import { Link } from "react-router-dom";

interface Props {
  icon: string;
  title: string;
  desc?: string;
  to?: string;
  accent?: boolean;
}

export default function SectionHeading({ icon, title, desc, to, accent }: Props) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="flex items-center gap-3">
        <span
          className={`flex h-11 w-11 items-center justify-center rounded-xl text-xl text-background-50 ${
            accent ? "bg-accent-500" : "bg-primary-500"
          }`}
        >
          <i className={icon} style={{ fontSize: "20px" }}></i>
        </span>
        <div>
          <h2 className="font-display text-2xl text-foreground-950">{title}</h2>
          {desc && <p className="mt-0.5 text-sm text-foreground-500">{desc}</p>}
        </div>
      </div>
      {to && (
        <Link
          to={to}
          className="inline-flex w-fit items-center gap-1 rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap text-primary-700 ring-1 ring-primary-200 hover:bg-primary-50 transition-colors"
        >
          查看全部 <i className="ri-arrow-right-line" style={{ fontSize: "15px" }}></i>
        </Link>
      )}
    </div>
  );
}